import React from "react"
import { mainGray } from "../../styles"

export default function AmountInput(props) {
  return (
    <input
      type="text"
      placeholder="Amount Invested"
      className="d-inline my-3 mx-1 savings-input"
      onKeyPress={props}
      onSubmit={props}
      {...props}
      style={{
        border: `1px solid ${mainGray}`,
        borderRadius: "8px",
        padding: "0.9rem 0 1rem 10px",
      }}
    />
  )
}
